import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { CHECK_EMAIL_PATH } from '../../constants/Constant';
import Cookies from 'js-cookie';

function PrivateRoutesCheck() {
  const accessToken = Cookies.get('access_token');
  return accessToken ? <Outlet /> : <Navigate to={CHECK_EMAIL_PATH} />;
}

export default PrivateRoutesCheck;
